/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoNoticeRemoveRequest model module.
 * @module model/EventsControllerDtoNoticeRemoveRequest
 * @version 1.0
 */
class EventsControllerDtoNoticeRemoveRequest {
    /**
     * Constructs a new <code>EventsControllerDtoNoticeRemoveRequest</code>.
     * @alias module:model/EventsControllerDtoNoticeRemoveRequest
     */
    constructor() { 
        
        EventsControllerDtoNoticeRemoveRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoNoticeRemoveRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoNoticeRemoveRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoNoticeRemoveRequest} The populated <code>EventsControllerDtoNoticeRemoveRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoNoticeRemoveRequest();

            if (data.hasOwnProperty('noticeNo')) {
                obj['noticeNo'] = ApiClient.convertToType(data['noticeNo'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoNoticeRemoveRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoNoticeRemoveRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['noticeNo'])) {
            throw new Error("Expected the field `noticeNo` to be an array in the JSON data but got " + data['noticeNo']);
        }

        return true;
    }


}



/**
 * @member {Array.<Number>} noticeNo
 */
EventsControllerDtoNoticeRemoveRequest.prototype['noticeNo'] = undefined;






export default EventsControllerDtoNoticeRemoveRequest;

